export const getStyleSheetByTitle = ( title : string ) : CSSStyleSheet | null => {
    let retVal : CSSStyleSheet | null = null;

    const styleSheets = document.styleSheets;

    for ( let i = styleSheets.length - 1; i >= 0; i-- ) {
        if ( styleSheets[ i ].title === title ) {
            retVal = styleSheets[ i ];
            break;
        }
    }

    return retVal;
}

export const getOrCreateStyleSheet = () : CSSStyleSheet | null => {
    return getOrCreateStyleSheetByTitle( 'dynamic_styles' );
}

export const getOrCreateStyleSheetByTitle = ( title : string ) : CSSStyleSheet | null => {
    let retVal : CSSStyleSheet | null = getStyleSheetByTitle( title );

    if ( !retVal ) {
        const styleSheet = document.createElement( 'style' );

        styleSheet.title = title;

        document.getElementsByTagName( 'head' )[ 0 ].appendChild( styleSheet );

        retVal = styleSheet.sheet;
    }

    return retVal;
}

export const ruleExists = ( styleSheet : CSSStyleSheet, ruleSelector : string ) : boolean => {
    let retVal = false;

    for ( const cssRule of styleSheet.cssRules as unknown as CSSStyleRule[] ) {
        if ( cssRule.selectorText === ruleSelector ) {
            retVal = true;
            break;
        }
    }

    return retVal;
}

const getInsertionIndex = ( styleSheet : CSSStyleSheet ) : number => {
    for ( let i = 0; i < styleSheet.cssRules.length; i++ ) {
        if ( styleSheet.cssRules[ i ] instanceof CSSMediaRule ) {
            return i;
        }
    }

    return styleSheet.cssRules.length;
}

export const appendRule = ( styleSheet : CSSStyleSheet, ruleSelector : string, ruleContent : string ) => {
    if ( styleSheet ) {
        styleSheet.insertRule( `${ruleSelector} ${ruleContent}`, getInsertionIndex( styleSheet ) );
    }
}

export const appendRuleIfNotExists = ( styleSheet : CSSStyleSheet, ruleSelector : string, ruleContent : string ) => {
    if ( styleSheet && !ruleExists( styleSheet, ruleSelector ) ) {
        styleSheet.insertRule( `${ruleSelector} ${ruleContent}`, getInsertionIndex( styleSheet ) );
    }
}

export const getOrCreateMediaRule = ( styleSheet : CSSStyleSheet, mediaCondition : string ) : CSSMediaRule | null => {
    for ( const cssRule of styleSheet.cssRules as unknown as CSSRule[] ) {
        if ( cssRule instanceof CSSMediaRule && cssRule.conditionText === mediaCondition ) {
            return cssRule;
        }
    }

    const index = styleSheet.insertRule( `@media ${mediaCondition} {}`, styleSheet.cssRules.length );

    return styleSheet.cssRules[ index ] as CSSMediaRule;
}

export const mediaRuleExists = ( mediaRule : CSSMediaRule, ruleSelector : string ) : boolean => {
    for ( const cssRule of mediaRule.cssRules as unknown as CSSStyleRule[] ) {
        if ( cssRule.selectorText === ruleSelector ) {
            return true;
        }
    }

    return false;
}

export const appendMediaRule = ( mediaRule : CSSMediaRule, ruleSelector : string, ruleContent : string ) => {
    mediaRule.insertRule( `${ruleSelector} ${ruleContent}`, mediaRule.cssRules.length );
}

export const appendMediaRuleIfNotExists = ( mediaRule : CSSMediaRule, ruleSelector : string, ruleContent : string ) => {
    if ( !mediaRuleExists( mediaRule, ruleSelector ) ) {
        mediaRule.insertRule( `${ruleSelector} ${ruleContent}`, mediaRule.cssRules.length );
    }
}
